import { render, staticRenderFns } from "./ArticleViewer.vue?vue&type=template&id=306fe5f0&scoped=true"
import script from "./ArticleViewer.vue?vue&type=script&lang=js"
export * from "./ArticleViewer.vue?vue&type=script&lang=js"
import style0 from "./ArticleViewer.vue?vue&type=style&index=0&id=306fe5f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306fe5f0",
  null
  
)

export default component.exports